export default function PHP_array_combine() {
  return (
    <div>
      <h1>PHP_array_combine</h1>
    </div>
  );
}
